import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesGreyWaterComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 6H21" fill="none" />
        <path d="M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6" fill="none" />
        <path
          d="M12 18C12.7956 18 13.5587 17.6895 14.1213 17.1367C14.6839 16.584 15 15.8343 15 15.0526C15 14.2105 14.5714 13.4105 13.7143 12.7368C12.8571 12.0632 12.2143 11.0526 12 10C11.7857 11.0526 11.1429 12.0632 10.2857 12.7368C9.42857 13.4105 9 14.2105 9 15.0526C9 15.8343 9.31607 16.584 9.87868 17.1367C10.4413 17.6895 11.2044 18 12 18Z"
          fill="none"
        />
        <path d="M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesGreyWaterComponent.displayName = 'IconAmenitiesGreyWater';

const IconAmenitiesGreyWater = React.memo(IconAmenitiesGreyWaterComponent);

export default IconAmenitiesGreyWater;
